/* Recommended / May also like
   PDP related-products only. Keep theme cards + theme Swiper.
   6 on desktop, max 15. Same product kind first (dessert plate → other dessert plates). */

(function () {
  'use strict';

  if (window.__BM_RECOMMENDED_MAY_ALSO_LIKE__) return;
  window.__BM_RECOMMENDED_MAY_ALSO_LIKE__ = true;

  var LIMIT = 15;
  var CACHE_KEY = 'bm-rel-catalog-v2';
  var MEMBER_KEY = 'bm-rel-membership-v2';
  var READY = 'bm-rel-ready';
  var CATEGORY_HANDLES = [
    'home-decor',
    'dinnerware',
    'bedroom',
    'drinkware',
    'kitchen',
    'bathroom',
    'serveware'
  ];

  function isProductPage() {
    if (document.body && document.body.classList.contains('product-template')) return true;
    if (window.meta && meta.page && meta.page.pageType === 'product') return true;
    return /\/products\//.test(window.location.pathname || '');
  }

  function currentHandle() {
    var m = (window.location.pathname || '').match(/\/products\/([^\/?#]+)/i);
    return m ? decodeURIComponent(m[1]).toLowerCase() : '';
  }

  function money(value) {
    var n = parseFloat(value);
    if (isNaN(n)) return '';
    return '$' + n.toFixed(2);
  }

  function specificKind(title) {
    var t = String(title || '').toLowerCase();
    if (/\bpasta bowl\b/.test(t)) return 'pasta bowl';
    if (/\bsoup bowl\b/.test(t)) return 'soup bowl';
    if (/\bserving bowl\b/.test(t)) return 'serving bowl';
    if (/\bdecorative bowl\b/.test(t)) return 'decorative bowl';
    if (/\bmixing bowl\b/.test(t)) return 'mixing bowl';
    if (/\b(dessert|desert) plate\b/.test(t)) return 'dessert plate';
    if (/\bdinner plate\b/.test(t)) return 'dinner plate';
    if (/\bsalad plate\b/.test(t)) return 'salad plate';
    if (/\bsoup plate\b/.test(t)) return 'soup plate';
    if (/\bserving plate\b/.test(t)) return 'serving plate';
    if (/\bpizza plate\b/.test(t)) return 'pizza plate';
    if (/\bplatter\b/.test(t)) return 'platter';
    if (/\bplate\b/.test(t)) return 'plate';
    if (/\bbowl\b/.test(t)) return 'bowl';
    if (/\btumbler\b/.test(t)) return 'tumbler';
    if (/\bmug\b/.test(t)) return 'mug';
    if (/\bduvet\b/.test(t)) return 'duvet';
    if (/\bcoverlet\b/.test(t)) return 'coverlet';
    if (/\btowel\b/.test(t)) return 'towel';
    if (/\bcushion|pillow\b/.test(t)) return 'pillow';
    return '';
  }

  function kindOf(product) {
    return specificKind(product && product.title) || String((product && product.product_type) || '').trim().toLowerCase();
  }

  function collectionToken(title) {
    return (String(title || '').trim().split(/\s+/)[0] || '').toLowerCase();
  }

  function inList(list, handle) {
    return list && list.indexOf(handle) !== -1;
  }

  function isAvailable(product) {
    var variants = (product && product.variants) || [];
    for (var i = 0; i < variants.length; i += 1) {
      if (variants[i] && variants[i].available) return true;
    }
    return false;
  }

  function firstImage(product) {
    if (!product) return '';
    if (product.featured_image) {
      return typeof product.featured_image === 'string'
        ? product.featured_image
        : product.featured_image.src || '';
    }
    var img = product.images && product.images[0];
    if (!img) return '';
    return typeof img === 'string' ? img : img.src || '';
  }

  function loadCollectionHandles(handle) {
    return fetch('/collections/' + handle + '/products.json?limit=250', {
      credentials: 'same-origin'
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        return (data.products || []).map(function (p) {
          return (p.handle || '').toLowerCase();
        });
      })
      .catch(function () {
        return [];
      });
  }

  function loadMembership() {
    try {
      var cached = sessionStorage.getItem(MEMBER_KEY);
      if (cached) return Promise.resolve(JSON.parse(cached));
    } catch (e) {}

    return Promise.all(
      CATEGORY_HANDLES.map(function (handle) {
        return loadCollectionHandles(handle).then(function (handles) {
          return { handle: handle, handles: handles };
        });
      })
    ).then(function (rows) {
      var map = { category: {} };
      rows.forEach(function (row) {
        map.category[row.handle] = row.handles;
      });
      try {
        sessionStorage.setItem(MEMBER_KEY, JSON.stringify(map));
      } catch (e) {}
      return map;
    });
  }

  function loadCatalog() {
    try {
      var cached = sessionStorage.getItem(CACHE_KEY);
      if (cached) return Promise.resolve(JSON.parse(cached));
    } catch (e) {}

    function page(n) {
      return fetch('/products.json?limit=250&page=' + n, { credentials: 'same-origin' }).then(function (r) {
        return r.json();
      });
    }

    return page(1).then(function (first) {
      var all = first.products || [];
      if (all.length < 250) return all;
      return Promise.all([page(2), page(3)]).then(function (rest) {
        rest.forEach(function (pack) {
          all = all.concat(pack.products || []);
        });
        return all;
      });
    }).then(function (all) {
      try {
        sessionStorage.setItem(CACHE_KEY, JSON.stringify(all));
      } catch (e) {}
      return all;
    });
  }

  function mixByKey(products, keyFn) {
    var buckets = {};
    var keys = [];
    products.forEach(function (p) {
      var key = keyFn(p) || 'other';
      if (!buckets[key]) {
        buckets[key] = [];
        keys.push(key);
      }
      buckets[key].push(p);
    });

    var mixed = [];
    var i = 0;
    while (mixed.length < LIMIT) {
      var added = false;
      keys.forEach(function (key) {
        if (buckets[key][i] && mixed.length < LIMIT) {
          mixed.push(buckets[key][i]);
          added = true;
        }
      });
      if (!added) break;
      i += 1;
    }
    return mixed;
  }

  function mixByCollection(products) {
    return mixByKey(products, function (p) {
      return collectionToken(p.title);
    });
  }

  function pickKindMates(current, catalog) {
    var handle = (current.handle || '').toLowerCase();
    var pageHandle = currentHandle();
    var want = specificKind(current.title);
    if (!want) return [];
    var matches = catalog.filter(function (p) {
      var h = (p.handle || '').toLowerCase();
      if (!h || h === handle || (pageHandle && h === pageHandle)) return false;
      return specificKind(p.title) === want;
    });
    return mixByCollection(matches);
  }

  function pickCategoryMates(current, catalog, membership) {
    var handle = (current.handle || '').toLowerCase();
    var i;
    for (i = 0; i < CATEGORY_HANDLES.length; i += 1) {
      var list = membership.category[CATEGORY_HANDLES[i]] || [];
      if (!inList(list, handle)) continue;
      var matches = catalog.filter(function (p) {
        var h = (p.handle || '').toLowerCase();
        return h && h !== handle && inList(list, h);
      });
      return mixByCollection(matches);
    }
    return [];
  }

  function pickTypeMates(current, catalog) {
    var handle = (current.handle || '').toLowerCase();
    var want = kindOf(current);
    var matches = catalog.filter(function (p) {
      return p && (p.handle || '').toLowerCase() !== handle && want && kindOf(p) === want;
    });
    return mixByCollection(matches);
  }

  function pickRelated(current, catalog, membership) {
    var inStock = (catalog || []).filter(isAvailable);
    var kind = pickKindMates(current, inStock);
    if (kind.length) return kind;
    var category = pickCategoryMates(current, inStock, membership || { category: {} });
    if (category.length) return category;
    return pickTypeMates(current, inStock);
  }

  function findSection() {
    var rec = document.querySelector('product-recommendations.related-products');
    if (rec) {
      return rec.closest('.section--related-products') || rec.closest('.shopify-section') || rec;
    }
    return document.querySelector('.section--related-products');
  }

  function markReady(section) {
    var root = section.classList.contains('section--related-products')
      ? section
      : section.querySelector('.section--related-products') || section;
    root.classList.add(READY);
  }

  function guardSection(section) {
    var rec = section.querySelector('product-recommendations') || document.querySelector('product-recommendations.related-products');
    if (!rec || rec.getAttribute('data-bm-rel-guard')) return;
    rec.setAttribute('data-bm-rel-guard', '1');
    var host = rec.closest('.shopify-section') || section;
    var nativeRemove = host.remove;
    host.remove = function () {
      if (host.classList.contains(READY) || host.querySelector('.' + READY)) return;
      nativeRemove.call(host);
    };
  }

  function fillBadges(col, product) {
    Array.prototype.forEach.call(col.querySelectorAll('.foxkit-preorder-badge, .f-badge--soldout, .f-badge--sale'), function (el) {
      el.remove();
    });

    var tags = (product.tags || []).filter(function (tag) {
      var raw = String(tag);
      if (raw.indexOf('tag__') === -1) return false;
      var type = (raw.split('__').pop() || '').split('_')[0].toLowerCase();
      return type !== 'sale';
    });
    var wrap = col.querySelector('.product-card__badge');

    if (!tags.length) {
      if (wrap) wrap.remove();
      return;
    }

    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'product-card__badge';
      var imageWrap = col.querySelector('.product-card__image-wrapper');
      if (!imageWrap) return;
      imageWrap.appendChild(wrap);
    }

    wrap.innerHTML = '';
    tags.forEach(function (tag) {
      var content = String(tag).split('__').pop() || '';
      var parts = content.split('_');
      var type = parts[0] || '';
      var name = parts[parts.length - 1] || '';
      if (!name) return;
      var span = document.createElement('span');
      span.className = 'f-badge f-badge--' + type;
      span.textContent = name;
      wrap.appendChild(span);
    });
  }

  function fillColumn(col, product) {
    var href = '/products/' + product.handle;
    var variant = (product.variants && product.variants[0]) || {};
    var imgSrc = firstImage(product);

    Array.prototype.forEach.call(col.querySelectorAll('a[href*="/products/"]'), function (a) {
      a.setAttribute('href', href);
    });

    Array.prototype.forEach.call(col.querySelectorAll('img'), function (img) {
      if (!imgSrc) return;
      img.src = imgSrc;
      img.setAttribute('src', imgSrc);
      img.removeAttribute('srcset');
      if (img.dataset) {
        img.dataset.src = imgSrc;
        img.dataset.srcset = '';
      }
      img.alt = product.title || '';
    });

    var titleEl = col.querySelector('.product-card__title a') || col.querySelector('.product-card__title');
    if (titleEl) titleEl.textContent = product.title || '';

    var saleEl = col.querySelector('.f-price-item--sale');
    var regularEls = col.querySelectorAll('.f-price-item--regular');
    var compare = parseFloat(variant.compare_at_price);
    var hasCompare = !isNaN(compare) && compare > parseFloat(variant.price);
    if (saleEl) saleEl.textContent = money(variant.price);
    Array.prototype.forEach.call(regularEls, function (el, i) {
      if (saleEl && i === 0 && hasCompare) {
        var s = el.querySelector('s') || el;
        s.textContent = money(variant.compare_at_price);
        el.style.display = '';
      } else if (!saleEl) {
        el.textContent = money(variant.price);
      } else if (saleEl && i === 0 && !hasCompare) {
        el.style.display = 'none';
      }
    });

    fillBadges(col, product);
  }

  function iconPrev() {
    return '<svg class="icon icon-slider-prev icon--medium" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.75 16.2505L6.5 10.0005L12.75 3.75049" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function iconNext() {
    return '<svg class="icon icon-slider-next icon--medium" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 3.74121L13.75 9.99121L7.5 16.2412" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function sectionRoot(section) {
    if (section.classList.contains('section--related-products')) return section;
    return section.querySelector('.section--related-products') || section;
  }

  function placeOwnArrows(host, grid) {
    var media = grid && grid.querySelector('.product-card__image-wrapper');
    if (!host || !media) return;
    var hostRect = host.getBoundingClientRect();
    var mediaRect = media.getBoundingClientRect();
    var top = Math.round(mediaRect.top - hostRect.top + mediaRect.height / 2);
    if (top > 0) host.style.setProperty('--bm-rel-arrow-top', top + 'px');
  }

  function bindOwnArrows(section, grid) {
    var host = sectionRoot(section);
    if (!host) return;

    host.classList.add(READY);
    host.style.position = 'relative';
    host.style.overflow = 'visible';
    placeOwnArrows(host, grid);

    if (host.querySelector('.bm-rel-arrow')) {
      placeOwnArrows(host, grid);
      return;
    }

    function go(dir) {
      var slider = section.querySelector('product-slider');
      var inst = slider && slider.sliderInstance && slider.sliderInstance.slider;
      if (inst) {
        if (dir < 0) inst.slidePrev();
        else inst.slideNext();
        return;
      }
      grid.scrollBy({ left: dir * (grid.clientWidth || 320), behavior: 'smooth' });
    }

    function make(dir, label, html) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bm-rel-arrow bm-rel-arrow--' + dir;
      btn.setAttribute('aria-label', label);
      btn.innerHTML = html;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        go(dir === 'prev' ? -1 : 1);
      });
      host.appendChild(btn);
    }

    make('prev', 'Previous', iconPrev());
    make('next', 'Next', iconNext());
    placeOwnArrows(host, grid);
  }

  function destroySlider(slider) {
    if (!slider) return;
    try {
      if (slider.sliderInstance && slider.sliderInstance.slider) {
        slider.sliderInstance.slider.destroy(true, true);
      }
    } catch (e) {}
    slider.sliderInstance = false;
  }

  function startSlider(section, grid) {
    var slider = section.querySelector('product-slider');
    var wrap = section.querySelector('.products-grid-wrap');
    if (!slider || !wrap || !grid) return false;
    if (!window.FoxTheme || !FoxTheme.Carousel) return false;

    Array.prototype.forEach.call(grid.children, function (col) {
      col.classList.add('f-column', 'swiper-slide');
      col.classList.remove('swiper-slide-duplicate');
    });
    Array.prototype.slice.call(grid.classList).forEach(function (name) {
      if (name.indexOf('f-grid') === 0 || name.indexOf('swipe-mobile') === 0) {
        grid.classList.remove(name);
      }
    });
    Array.prototype.slice.call(wrap.classList).forEach(function (name) {
      if (name.indexOf('swipe-mobile') === 0) wrap.classList.remove(name);
    });
    grid.classList.add('swiper-wrapper');
    wrap.classList.add('swiper', 'swiper-equal-height');

    destroySlider(slider);

    slider.dataset.enableSlider = 'true';
    slider.enableSlider = true;
    slider.init = function () {};
    slider.initSlider = function () {};
    slider.destroySlider = function () {};

    slider.sliderInstance = new FoxTheme.Carousel(wrap, {
      slidesPerView: 1.2,
      spaceBetween: 16,
      loop: true,
      loopAdditionalSlides: 3,
      breakpoints: {
        750: { slidesPerView: 4, spaceBetween: 12, loop: true },
        990: { slidesPerView: 6, spaceBetween: 16, loop: true },
      },
      threshold: 2,
      watchOverflow: false,
    });
    slider.sliderInstance.init();
    return true;
  }

  function render(products) {
    if (!products.length) return false;

    var section = findSection();
    if (!section) return false;

    var grid = section.querySelector('.products-grid');
    if (!grid) return false;

    var template = grid.querySelector('.f-column:not(.swiper-slide-duplicate), .swiper-slide:not(.swiper-slide-duplicate)');
    if (!template) return false;

    guardSection(section);

    if (grid.getAttribute('data-bm-rel-filled') === '1') {
      markReady(section);
      bindOwnArrows(section, grid);
      var startedAgain = startSlider(section, grid);
      window.setTimeout(function () {
        placeOwnArrows(sectionRoot(section), grid);
      }, 300);
      return startedAgain;
    }

    destroySlider(section.querySelector('product-slider'));

    Array.prototype.forEach.call(grid.querySelectorAll('.swiper-slide-duplicate'), function (el) {
      el.remove();
    });

    var frag = document.createDocumentFragment();
    products.forEach(function (product) {
      var col = template.cloneNode(true);
      col.classList.add('f-column', 'swiper-slide');
      fillColumn(col, product);
      frag.appendChild(col);
    });

    grid.innerHTML = '';
    grid.appendChild(frag);
    grid.setAttribute('data-bm-rel-filled', '1');
    markReady(section);
    bindOwnArrows(section, grid);
    var started = startSlider(section, grid);
    window.setTimeout(function () {
      placeOwnArrows(sectionRoot(section), grid);
    }, 300);
    return started;
  }

  function run() {
    if (!isProductPage()) return;

    var handle = currentHandle();
    if (!handle) return;

    Promise.all([
      fetch('/products/' + handle + '.js', { credentials: 'same-origin' }).then(function (r) {
        return r.json();
      }),
      loadCatalog(),
      loadMembership()
    ])
      .then(function (pair) {
        var related = pickRelated(pair[0], pair[1], pair[2]);
        if (!related.length) return;

        var tries = 0;
        var timer = window.setInterval(function () {
          if (render(related) || tries > 50) window.clearInterval(timer);
          tries += 1;
        }, 200);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
